import React, { useState, useEffect } from 'react'
import { Form, Button, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'

// Props:
// - required?: boolean (default true)
// - initial?: { viewedPrivacy, acceptedPrivacy, viewedTerms, acceptedTerms }
// - onChange: function(state)
const PolicyConsent = ({ required = true, initial, onChange }) => {
  const [viewedPrivacy, setViewedPrivacy] = useState(!!initial?.viewedPrivacy)
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(!!initial?.acceptedPrivacy)
  const [viewedTerms, setViewedTerms] = useState(!!initial?.viewedTerms)
  const [acceptedTerms, setAcceptedTerms] = useState(!!initial?.acceptedTerms)

  const [showPrivacy, setShowPrivacy] = useState(false)
  const [showTerms, setShowTerms] = useState(false)

  useEffect(() => {
    onChange && onChange({ viewedPrivacy, acceptedPrivacy, viewedTerms, acceptedTerms })
  }, [viewedPrivacy, acceptedPrivacy, viewedTerms, acceptedTerms, onChange])

  const disablePrivacyAccept = required && !viewedPrivacy
  const disableTermsAccept = required && !viewedTerms

  return (
    <div className='my-3'>
      {/* Terms section */}
      <Form.Group controlId='policyConsentTerms' className='mb-3'>
        <div className='d-flex align-items-center justify-content-between'>
          <strong>Terms & Conditions</strong>
          <div>
            <Button size='sm' variant='outline-primary' onClick={() => { setShowTerms(true); }}>View</Button>{' '}
            {/* <Link to='/terms' target='_blank' rel='noopener noreferrer' className='small'>Open in new tab</Link> */}
          </div>
        </div>
        <div role='radiogroup' aria-label='Terms & Conditions consent' className='mt-2'>
          <Form.Check
            id='terms-accept'
            type='radio'
            name='terms-consent'
            label='I accept'
            checked={acceptedTerms === true}
            onChange={() => setAcceptedTerms(true)}
            disabled={disableTermsAccept}
          />
          <Form.Check
            id='terms-decline'
            type='radio'
            name='terms-consent'
            label='I do not accept'
            checked={acceptedTerms === false}
            onChange={() => setAcceptedTerms(false)}
          />
        </div>
        {required && !acceptedTerms && (
          <div className='text-danger small mt-1'>You must view and accept the Terms & Conditions to continue.</div>
        )}
      </Form.Group>

      {/* Privacy section */}
      <Form.Group controlId='policyConsentPrivacy' className='mb-2'>
        <div className='d-flex align-items-center justify-content-between'>
          <strong>Privacy Policy</strong>
          <div>
            <Button size='sm' variant='outline-primary' onClick={() => { setShowPrivacy(true); }}>View</Button>{' '}
            {/* <Link to='/privacy' target='_blank' rel='noopener noreferrer' className='small'>Open in new tab</Link> */}
          </div>
        </div>
        <div role='radiogroup' aria-label='Privacy Policy consent' className='mt-2'>
          <Form.Check
            id='privacy-accept'
            type='radio'
            name='privacy-consent'
            label='I accept'
            checked={acceptedPrivacy === true}
            onChange={() => setAcceptedPrivacy(true)}
            disabled={disablePrivacyAccept}
          />
          <Form.Check
            id='privacy-decline'
            type='radio'
            name='privacy-consent'
            label='I do not accept'
            checked={acceptedPrivacy === false}
            onChange={() => setAcceptedPrivacy(false)}
          />
        </div>
        {required && !acceptedPrivacy && (
          <div className='text-danger small mt-1'>You must view and accept the Privacy Policy to continue.</div>
        )}
      </Form.Group>

      {/* Terms Modal */}
      <Modal show={showTerms} onHide={() => setShowTerms(false)} size='lg' onShow={() => setViewedTerms(true)} aria-labelledby='modal-terms'>
        <Modal.Header closeButton>
          <Modal.Title id='modal-terms'>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>For the complete Terms & Conditions, you may also visit the dedicated page.</p>
          <p><Link to='/terms' target='_blank' rel='noopener noreferrer'>Open Terms & Conditions</Link></p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowTerms(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      {/* Privacy Modal */}
      <Modal show={showPrivacy} onHide={() => setShowPrivacy(false)} size='lg' onShow={() => setViewedPrivacy(true)} aria-labelledby='modal-privacy'>
        <Modal.Header closeButton>
          <Modal.Title id='modal-privacy'>Privacy Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>For the complete Privacy Policy, you may also visit the dedicated page.</p>
          <p><Link to='/privacy' target='_blank' rel='noopener noreferrer'>Open Privacy Policy</Link></p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowPrivacy(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default PolicyConsent
